import React from 'react';

import { Text, TextType } from 'ui-components/components/text';

import { FormattedCurrency } from '../../../../../../components/formatted-currency';
import { useGetNumberOfIncludedUserSeatsForPlan, useSelectedPlan } from '../../../hooks/use-plan-details';
import { useGetUserSeatsAddOnData } from '../../../hooks/use-get-user-seats-addon-data';

import { messages } from './messages';
import collapsibleStyle from '../collapsible/collapsible.module.less';
import { useManageSubscriptionDrawerContext } from '../../../context/manage-subscription-drawer-context';

export const CollapsiblePlanUsersHeader = ({ shouldHidePrice = false }) => {
  const { desiredNumberOfAdditionalUsers } = useManageSubscriptionDrawerContext();
  const selectedPlan = useSelectedPlan();
  const numberOfIncludedUserSeatsForSelectedPlan = useGetNumberOfIncludedUserSeatsForPlan(selectedPlan.billingPlanId);
  const userAddOnData = useGetUserSeatsAddOnData();
  return (
    <div className={collapsibleStyle['header-text-wrapper']}>
      <Text textType={TextType.H3} value={messages.accountUsersTitle} />
      <div className={collapsibleStyle['header-price']}>
        <Text
          className={collapsibleStyle['header-selected-state-label']}
          formattedMessageValues={{
            includedUserCount: numberOfIncludedUserSeatsForSelectedPlan,
            addedUserCount: desiredNumberOfAdditionalUsers,
          }}
          textType={TextType.Caption}
          value={messages.accountUsersIncludedAndAdded}
        />
        {!shouldHidePrice && (
          <Text
            textType={TextType.H3}
            value={
              <FormattedCurrency
                currencyCode={userAddOnData.unitCost.code}
                value={desiredNumberOfAdditionalUsers * userAddOnData.unitCost.value}
              />
            }
          />
        )}
      </div>
    </div>
  );
};
